import { useQueryGrid, useReloadQuery } from '@gogame/query';

import { loadDataTable } from 'scenes/Labels/sources/labels';

import { grid } from './queryKeyFactory';

export const useLoadLabels = (params) => {
  return useQueryGrid(
    grid({ ...params, columns: [...params.columns.order].sort() }),
    (_, { signal }) => loadDataTable(params, { signal })
  );
};

export const useReLoadLabels = (params) => useReloadQuery(grid(params));
